import React from 'react';
import { Trans as GatsbyTrans } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';

interface Props {
  children: string;
}

const TransHTML: React.FC<Props> = ({ children }) => {
  return (
    <GatsbyTrans components={{ b: <b />, i: <i />, u: <u />, s: <s />, sup: <sup />, sub: <sub />, br: <br />, ul: <StyledUl />, li: <StyledLi /> }}>
      {children}
    </GatsbyTrans>
  );
};

export default TransHTML;

const StyledUl = styled.ul``;

const StyledLi = styled.li`
  font-size: inherit;
  line-height: inherit;
  font-family: inherit;
  color: inherit;
  margin-bottom: 0;
`;
